import NewsContent from "./NewsContent";

export default function News() {
  return <NewsContent />;
}
